import React from 'react';
import { Link } from 'gatsby';
import { FooterLogo } from './FooterLogo';
import { FooterHeading } from './FooterHeading';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
library.add(fab)

export const Footer = () => {
  return(
  <footer className="footer">
    <div className="container">
      <div className="row">
        <div className="col-md-3">
          <FooterLogo />
          <ul className="social-menu" style={{ marginTop: "15px" }}>
            <li className="d-inline-block">
              <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer" className="social-menu__link">
                <FontAwesomeIcon icon={['fab', 'facebook-f']} className="social-menu__icon" />
              </a>  
            </li>
            <li className="d-inline-block">
              <a href="http://bit.ly/gardenTeam" target="_blank" rel="noopener noreferrer" className="social-menu__link">
                <FontAwesomeIcon icon={['fab', 'whatsapp']} className="social-menu__icon" />
              </a>  
            </li>
            <li className="d-inline-block">
              <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" className="social-menu__link">
                <FontAwesomeIcon icon={['fab', 'instagram']} className="social-menu__icon" />
              </a>  
            </li>
          </ul>
        </div>
        <div className="col-md-2 col-sm-5 offset-md-1 mt-4 mt-md-0">
          <FooterHeading heading="company" />
          <ul className="footer-menu">
            <li className="footer-menu__list">
              <Link to="/about-us" className="footer-menu__link">about us</Link>
            </li>
            <li className="footer-menu__list">
              <Link to="/refer-a-friend" className="footer-menu__link">refer friend</Link>
            </li>
          </ul>
        </div>
        
        <div className  ="col-md-3 mt-4 mt-md-0">
          <FooterHeading heading="information" />
          <ul className="footer-menu">
          <li className="footer-menu__list">
              <Link to="/cancellation" className="footer-menu__link">refund/Cancellation</Link>
            </li>
            {/* <li className="footer-menu__list">
              <Link to="/" className="footer-menu__link">payment &amp; security</Link>
            </li> */}
            <li className="footer-menu__list">
              <Link to="/warranty" className="footer-menu__link">warranty </Link>
            </li>
            {/* <li className="footer-menu__list">
              <Link to="/" className="footer-menu__link">maintaince</Link>
            </li> */}
            <li className="footer-menu__list">
              <Link to="/privacy-policy" className="footer-menu__link">privacy</Link>
            </li>
            <li className="footer-menu__list">
              <Link to="/terms-and-conditions" className="footer-menu__link">terms &amp; condtions</Link>
            </li>
          </ul>
        </div>

        <div className="col-md-3 col-sm-6 mt-4 mt-md-0">
          <FooterHeading heading="help" />
          <ul className="footer-menu">
            <li className="footer-menu__list">
              <a href="tel: +91-998027556" className="footer-menu__link">
                <FontAwesomeIcon icon={faPhone} style={ { transform: "scaleX(-1)", marginRight: "10px" } }/>
                <span className="phone-text">+91-9980175567</span>
              </a>
            </li>
            <li className="footer-menu__list">
              <a href="mailto:contact@garden.com" className="footer-menu__link">
                <FontAwesomeIcon icon={faEnvelope} style={{marginRight: "10px"}} />
                <span className="phone-text">contact@garden.com</span>
              </a>
            </li>
            <li className="footer-menu__list">
              <a href="tel:+91-998027556" className="footer-menu__link">
                <FontAwesomeIcon icon={['fab', 'whatsapp']} style={{marginRight: "10px"}} />
                <span className="phone-text">+91-9980175567</span>
              </a>
            </li>
            
          </ul>
        </div>
      </div>
    </div>
  </footer>
  );
}
